import { render, staticRenderFns } from "./postCard.vue?vue&type=template&id=3d737258&scoped=true&"
import script from "./postCard.vue?vue&type=script&lang=js&"
export * from "./postCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d737258",
  null
  
)

export default component.exports